import { render, staticRenderFns } from "./EchangeList.vue?vue&type=template&id=5fe54b5f"
import script from "./EchangeList.vue?vue&type=script&lang=ts"
export * from "./EchangeList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports